/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.ActivityReportFilter */
export var ActivityReportFilter;
(function (ActivityReportFilter) {
    ActivityReportFilter[ActivityReportFilter["None"] = 0] = "None";
    ActivityReportFilter[ActivityReportFilter["TotalListingViews"] = 1] = "TotalListingViews";
    ActivityReportFilter[ActivityReportFilter["ViewedFromEmailsSent"] = 2] = "ViewedFromEmailsSent";
    ActivityReportFilter[ActivityReportFilter["ViewedFromProspectListEmails"] = 3] = "ViewedFromProspectListEmails";
    ActivityReportFilter[ActivityReportFilter["ViewedFromEmailAlerts"] = 4] = "ViewedFromEmailAlerts";
    ActivityReportFilter[ActivityReportFilter["ViewedFromEmailCampaign"] = 5] = "ViewedFromEmailCampaign";
    ActivityReportFilter[ActivityReportFilter["ViewedViaListingWebsite"] = 6] = "ViewedViaListingWebsite";
})(ActivityReportFilter || (ActivityReportFilter = {}));
/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.TimePeriod */
export var TimePeriod;
(function (TimePeriod) {
    TimePeriod[TimePeriod["None"] = 0] = "None";
    TimePeriod[TimePeriod["Last30Days"] = 30] = "Last30Days";
    TimePeriod[TimePeriod["Last90Days"] = 90] = "Last90Days";
    TimePeriod[TimePeriod["Last180Days"] = 180] = "Last180Days";
})(TimePeriod || (TimePeriod = {}));
/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.Website */
export var Website;
(function (Website) {
    Website[Website["None"] = 0] = "None";
    Website[Website["LoopNet"] = 1] = "LoopNet";
    Website[Website["CityFeet"] = 10] = "CityFeet";
    Website[Website["CityfeetND"] = 20] = "CityfeetND";
    Website[Website["CoStarProperty_ListingDiamondAd"] = 30] = "CoStarProperty_ListingDiamondAd";
    Website[Website["Showcase"] = 40] = "Showcase";
    Website[Website["CoStarSuite"] = 50] = "CoStarSuite";
})(Website || (Website = {}));
import { VisitorGroup } from "../../../../../CoStar/Api/ListingAnalytics/ViewModels/Enums/index.js";
/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.VisitorGroup */
export { VisitorGroup };
/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.ImpressionType */
export var ImpressionType;
(function (ImpressionType) {
    ImpressionType[ImpressionType["None"] = 0] = "None";
    ImpressionType[ImpressionType["All"] = 1] = "All";
    ImpressionType[ImpressionType["Search"] = 2] = "Search";
    ImpressionType[ImpressionType["Detail"] = 3] = "Detail";
})(ImpressionType || (ImpressionType = {}));
/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.ImpressionSourceType */
export var ImpressionSourceType;
(function (ImpressionSourceType) {
    ImpressionSourceType[ImpressionSourceType["None"] = 0] = "None";
    ImpressionSourceType[ImpressionSourceType["All"] = 1] = "All";
    ImpressionSourceType[ImpressionSourceType["Public"] = 2] = "Public";
    ImpressionSourceType[ImpressionSourceType["Professional"] = 3] = "Professional";
})(ImpressionSourceType || (ImpressionSourceType = {}));
/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.ImpressionDurationGroupByType */
export var ImpressionDurationGroupByType;
(function (ImpressionDurationGroupByType) {
    ImpressionDurationGroupByType[ImpressionDurationGroupByType["None"] = 0] = "None";
    ImpressionDurationGroupByType[ImpressionDurationGroupByType["Day"] = 1] = "Day";
    ImpressionDurationGroupByType[ImpressionDurationGroupByType["Week"] = 2] = "Week";
    ImpressionDurationGroupByType[ImpressionDurationGroupByType["Month"] = 3] = "Month";
})(ImpressionDurationGroupByType || (ImpressionDurationGroupByType = {}));
/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.VisitorDetailOrderByType */
export var VisitorDetailOrderByType;
(function (VisitorDetailOrderByType) {
    VisitorDetailOrderByType[VisitorDetailOrderByType["None"] = 0] = "None";
    VisitorDetailOrderByType[VisitorDetailOrderByType["Company"] = 1] = "Company";
    VisitorDetailOrderByType[VisitorDetailOrderByType["Location"] = 2] = "Location";
    VisitorDetailOrderByType[VisitorDetailOrderByType["VisitorCount"] = 3] = "VisitorCount";
    VisitorDetailOrderByType[VisitorDetailOrderByType["MostRecentlyViewed"] = 4] = "MostRecentlyViewed";
    VisitorDetailOrderByType[VisitorDetailOrderByType["IsCoStarProductUsers"] = 5] = "IsCoStarProductUsers";
})(VisitorDetailOrderByType || (VisitorDetailOrderByType = {}));
/** CoStar.Api.ListingAnalyticsSub.ViewModels.Enums.ListingHistoryOrderByType */
export var ListingHistoryOrderByType;
(function (ListingHistoryOrderByType) {
    ListingHistoryOrderByType[ListingHistoryOrderByType["None"] = 0] = "None";
    ListingHistoryOrderByType[ListingHistoryOrderByType["Date"] = 1] = "Date";
    ListingHistoryOrderByType[ListingHistoryOrderByType["Action"] = 2] = "Action";
    ListingHistoryOrderByType[ListingHistoryOrderByType["PerformedBy"] = 3] = "PerformedBy";
})(ListingHistoryOrderByType || (ListingHistoryOrderByType = {}));
